import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { fetchLanguageRules } from '../api'
import { languageRulesKeys } from '../queryKeys'

const useGetLanguageRulesQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useQuery(
    languageRulesKeys.list(accountId),
    () => fetchLanguageRules({ accountId }),
    {
      staleTime: 1000 * 60 * 1,
    }
  )
}

export default useGetLanguageRulesQuery
